const Footer = () => {
    return(
        <footer>
            <div className="footer">
                Application Developed By: University of Kentucky's <a href="https://cph.uky.edu/research/centers/public-health-analytics-informatics" target="_blank" rel="noreferrer">College of Public Health (PHAI)</a>
                <br />
                With Funding Provided By: Commonwealth of Kentucky through the Federal Grant "Money Follows the Person (MFP)"
            </div>
        </footer>
        
    )

}

export default Footer;